import { Button, Center, Image } from "@mantine/core";
import { modals } from "@mantine/modals";
import SRD_DataTable from "components/DataTable";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { download, getLibraryList } from "../apis/adminLibraryApis";

import { PAGE_SIZE } from "CommonData";
import { userState } from "pages/Login/atom/userState";
import { useQuery } from "react-query";
import { useRecoilState } from "recoil";

function LibraryDataTable() {
  const navigate = useNavigate();
  const [user, setUser] = useRecoilState(userState);
  const groupId = user.fn_group_id;
  const [searchParams, setSearchparams] = useSearchParams();

  const page = Number(searchParams.get("page")) || 1;

  const setPage = (newPage) => {
    const next = new URLSearchParams(searchParams);
    if (newPage){
      next.set("page" , String(newPage));
    }
    else {
      next.set("page", "1");
    }
    setSearchparams(next);
  }

  const { data } = useQuery(["libraryLists", page], () =>
    getLibraryList(PAGE_SIZE, page,groupId)
  );

  useEffect(() => {
    if (!data || data?.length < 1) return;
    data.map((item) => {
      let used_scope = "전체";
      if (item.menu !== "L"){
        used_scope = "그룹 내부";
      }
      item["used_scope"] = used_scope;
    });
  });

  const showImage = (e) => {
    modals.openConfirmModal({
      title: "이미지 ",
    //  centered: true,
      zIndex: 2050,
      labels: { confirm: "다운로드", cancel: "닫기" },
      confirmProps: { color: "blue" },
      children: (
        <Center>
          <Image
            src={`/static/files/${e.record.download_link}`}
            alt="With default placeholder"
            fit="none"
            withPlaceholder
          />
        </Center>
      ),    
        onConfirm: () => {
          download(e.record);
        }, 
     });
  };

  const columns = [
    {
      accessor: "index",
      title: "번호",
      textAlignment: "center",
      width: 30,
      render: (record) => record?.rnum,
    },
    {
      accessor: "used_scope",
      title: "공개범위",
      textAlignment: "center",  
    },
    {
      accessor: "title",
      title: "이름",
      textAlignment: "center",
      cellsStyle: {
        color: "blue",
       textDecoration: "underline",
      },
      onClick: function (e) {
        navigate(`/admin/library/${e.record.no}`, {state: {pg: page}});
      },
    },
    {
      accessor: "file_type",
      title: "유형",
      textAlignment: "center",
    },
    {
      accessor: "download_link",
      textAlignment: "center",
      title: "이미지",
      onClick: function (e) {showImage(e);},
      render: (e) => (
        <Center>
          <Image
            src={`/static/files/${e.download_link}`}
            alt="With default placeholder"
            withPlaceholder
            fit="fill"
            maw={150}
            height={80}
          />
        </Center>
      ),
    },
  ];

  const RegisterButton = () => {
    return (
      <Button variant="default" onClick={() => navigate("/admin/library/add", {state: {pg: page}})}>
        등록관리
      </Button>
    );
  };

  return (
    <>
      <SRD_DataTable
        data={data}
        columns={columns}
        registerButton={<RegisterButton />}
        page={page}
        setPage={setPage}
      />
    </>
  );
}

export default LibraryDataTable;
